import {api} from '_api';

import type {Finder, Mutator} from '_types/swr';

import {unwrap} from '_utils/axios';
import {parseKey} from '_utils/swr';
import {Desk} from "_types/models/Desk";
import {RequestDeskToken} from "_types/requests/Client/desk";
import {GeneratedDeskToken} from "_types/responses/generated-desk-token";


export const findDeskByCount: Finder<Desk[]> = async ({queryKey}) => {
    const url = parseKey(queryKey);
    const response = await api.get<Desk[]>(url);

    return await unwrap(response);
};

export const findDesk: Finder<Desk> = async ({queryKey}) => {
    const url = parseKey(queryKey);
    const response = await api.get<Desk>(url);

    return await unwrap(response);
};

export const deskToken: Mutator<GeneratedDeskToken, RequestDeskToken> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<GeneratedDeskToken>(url, payload);

    return await unwrap(response);
};
